import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import RichText from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import { Wrapper } from "./rich-text-section-component-styles";

export default function RichTextSection() {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={id}
      data-testid="rich-text-editor-wrapper"
    >
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Wrapper>
            <Element
              id="rich-text-section"
              is={RichText}
              text="<h3 style='text-align:center;'>Visit the first digital conference.</h3><p>Over three days of unscripted interviews and interactive workshops, attendees with an eye on emerging trends will hear from and collaborate with <strong>entrepreneurs, artists, athletes, scientists and thinkers</strong> for a first look at the seismic shifts occurring in the way we live, work and play.</p><p>FOODPhilippines is a branding initiative of the Center for International Trade Expositions & Missions (CITEM) that enforces the image of the Philippines as a top source of quality food products derived from fresh.<br/></p><h4 style='text-align:center;'>Visit the first digital conference.</h4><figure class='image ck-widget ck-widget_with-resizer image-style-align-left' contenteditable='false'><img alt src=https://user-images.githubusercontent.com/55299043/126532256-9d90966d-594c-427c-8388-758c4003eac6.jpg ></img></figure><ul><li>10 technologies that will transform the global economy by 2025</li><li>The key to surviving this new industrial revolution is leading it. That requires two key elements of agile businesses.</li><li>Learn what it takes to hire and inspire your talent with an employee-centric organizational model. Get our free guide: 5 keys to successful organizational design </li><li>Earth is the third planet from the Sun and the only astronomical object known to harbor life. </li></ul>"
            />
          </Wrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

RichTextSection.craft = {
  custom: {
    displayName: "Rich text section",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
